import * as React from 'react';

import { ImageElement } from 'src/lib/flow/FlowQuestion';

type ImageInputProps = {
  questionKey: string;
  props: ImageElement['props'];
};

const ImageEl: React.FC<ImageInputProps> = ({ questionKey, props }) => {
  return <img key={questionKey} src={props.src} alt={props.alt} width={props.width} />;
};

export default ImageEl;
